import {HttpClient, HttpParams} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Powiadomienie} from '../models/powiadomienie.model';
import { environment } from 'src/environments/environment';
import {BehaviorSubject, Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';
import {PowiadomienieFiltrModel} from '../models/powiadomienie-filtr.model';
import {KrsEntryService} from './krs-entry.service';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  notificationApi: string;
  loading$ = new BehaviorSubject<boolean>(false);

  constructor(
    private http: HttpClient, private krsEntryService: KrsEntryService
  ) {
    this.notificationApi = environment.notificationUrl;
  }

  getFilterNotifications(filter: PowiadomienieFiltrModel): Observable<Powiadomienie[]> {
    this.loading$.next(true);
    let params = new HttpParams();
    if (filter !== null) {
      if (filter.krs !== null) {
        filter.krs = this.krsEntryService.normalizeKRS(filter.krs);
      }
      params = this.convertToHttpParams(filter);
    }

    params = params.set('module', 'NEWSLETTER');
    params = params.set('pageNumber', '0');
    params = params.set('IsAscending', 'false');
    params = params.set('orderBy', 'registrationDate');
    params = params.set('pageSize', '1000');

    return this.http.get<Powiadomienie[]>(`${this.notificationApi}messages`, {params})
      .pipe(
        map(notifications => {
          let object: any;
          notifications = notifications.filter(notif => notif.typeCode !== '8');
          notifications.forEach(notification => {
            notification.receiveDate = new Date(notification.receiveDate);
            notification.registrationDate = new Date(notification.registrationDate);
            notification.payload = JSON.parse(notification.payload);
            object = notification.payload;
            if (notification.payload != null) {
              notification.krs = object.KRS;
              notification.nazwaPodmiotu = object.NazwaPodmiotu;
            }
            notification.dsRowClassNames = notification.wasSeen ? '' : 'ds-row-primary-text ds-row-primary-background';
          });
          this.loading$.next(false);
          return notifications;
        }),
        catchError(() => {
          this.loading$.next(false);
          return of([]);
        })
      );
  }

  sendNotificationSeen(id: string): Observable<any> {
    return this.http.put<any>(`${this.notificationApi}messages/setseen`, { id });
  }

  deleteNotification(id: string): Observable<any> {
    return this.http.delete<any>(`${this.notificationApi}messages/${id}`);
  }

  convertToHttpParams(obj: any): HttpParams {
    return Object.getOwnPropertyNames(obj)
      .filter((key: string) => {
        if (Array.isArray(obj[key])) {
          return obj[key].length;
        }
        return obj[key];
      })
      .reduce((p, key) => p.append(key, obj[key]), new HttpParams());
  }

}
